module.exports = __webpack_public_path__ + "img/obstetrics-gynaecology.d075a5f2.png";